
















































































import { defineComponent, reactive, ref, Ref, computed, watch, onMounted, toRefs } from '@vue/composition-api';
import { ChevronLeftIcon, JumpIcon } from 'tdesign-icons-vue';

import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';

// 引入 compositions
import loginWithPhoneHandler from '@/renderer/components/login/compositions/loginWithPhoneHandler';
import userValidator, { validatePhoneNumber, validateSMS } from '@/renderer/components/user/compositions/userValidator';

// 引入工具类
import { checkIsOauth2, getChannel } from '@/renderer/scripts/composition/channel';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import store from '@/renderer/store/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { getDeviceName, getTencentCaptchaLanguage } from '@/renderer/scripts/utils/tools/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import user, { User } from '@/renderer/scripts/utils/user';
import { LoginActionKeyMap } from '@/renderer/scripts/utils/user/UserTypingMap';
import vistor, { VistorInfo } from '@/renderer/scripts/utils/vistor';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import ipc from '@/renderer/scripts/utils/ipc';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import collectAccessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/collect';
import errorPhoneTips from '@/renderer/components/login/compositions/errorPhoneTips';
import i18n, { i18n_t } from '@/locales/i18n';

const defaultCode = '+86';
const defaultPhone = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_COFILE_PHONE : '';
const defaultSms = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_COFILE_SMS : '';

export default defineComponent({
  components: {
    ChevronLeftIcon,
    JumpIcon,
    AgreementCheckbox,
  },
  props: {
    vistorLogin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = context.root;
    const formData = reactive({
      code: defaultCode,
      phoneNumber: store.getters.phoneNumber || defaultPhone,
      sms: defaultSms,
      remember: store.getters.remember || false,
    });
    const { vistorLogin } = toRefs(props);
    const { isCounting, smsText, getSMS, resetSeconds } = loginWithPhoneHandler(vistorLogin);
    const { rules } = userValidator(formData);
    const phoneIsCorrect = ref(false);
    const smsIsCorrect = ref(false);
    const showAgreementPopup = ref(false);
    const loginAction = computed(() => store.getters.loginAction); // login | bindPhone
    const phoneMaxLen = computed(() => (formData.code === '+86' ? 11 : 20));
    const loginBindType = computed(() => store.getters.loginBindType);
    const agreementRef = ref<AgreementComponent | null>(null);

    // 当前环境所属的渠道
    const { channelTag } = getChannel();
    // 防水墙
    let captcha: null | any = null;
    const captchaInfo = reactive({
      captchaTicket: '',
      captchaRandstr: '',
    });
    const loginStep: Ref<'' | 'sendingSms' | 'logining'> = ref('');
    watch([() => formData.code, () => formData.phoneNumber, () => formData.sms], () => {
      phoneIsCorrect.value = validatePhoneNumber(formData.code, `${formData.phoneNumber}`);
      smsIsCorrect.value = validateSMS(`${formData.sms}`);
    });

    // 初始化重置countryCode为默认值
    user.setCountryCode(defaultCode);
    const methods = {
      phonePrefixFilter,
      // 手机前缀改变
      handleCodeChange(val: any) {
        user.setCountryCode(val);
        if (formData.phoneNumber && formData.phoneNumber.length > phoneMaxLen.value) {
          formData.phoneNumber = formData.phoneNumber.substring(0, phoneMaxLen.value);
        }
      },
      // 点击发送验证码
      clickSendSMS() {
        if (!formData.phoneNumber) {
          tips.error(i18n_t('请先输入手机号'));
          return;
        }
        methods.sendSMS();
      },
      emitNoEnterprise() {
        const wechatCode = vm.$route.query?.code || '';
        ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_NO_ENTERPRISE_DIALOG, {
          code: formData.code,
          phoneNumber: formData.phoneNumber,
          sms: formData.sms,
          wechatCode,
        });
      },
      // 发送验证码
      async sendSMS() {
        loginStep.value = 'sendingSms';
        let codeType = '';
        if (loginAction.value === User.LoginActionKey.login) {
          codeType = 'sign-in';
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInMeeting) {
          codeType = 'bind-meeting-phone';
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInWeChat) {
          codeType = 'bind-wechat-phone';
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInWeCom) {
          codeType = 'bind-wework-phone';
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInYufu) {
          codeType = 'bind-yufu-phone';
        } else if (
          [User.LoginBindTypeKey.bindPhoneInSSO, User.LoginBindTypeKey.bindPhoneInLDAP].includes(loginBindType.value)
        ) {
          codeType = 'bind-account-phone';
        }
        const smsResult = await getSMS({
          countryCode: formData.code,
          phoneNumber: formData.phoneNumber as string,
          type: codeType,
          ...(captchaInfo.captchaTicket && captchaInfo),
          collectToken: vm.$store.getters.collectToken,
        });
        if (smsResult.error) {
          if (['GraphicCaptchaNotFound', 'InvalidGraphicCaptcha'].includes((smsResult.error as any).code)) {
            // 需要图形验证码之后重新发送
            captcha.show();
          } else if ((smsResult.error as any).code === 'PhoneNumberNotInAllowlist') {
            reporter.report('login_not_joined', {
              tips: 'true',
            });
            if (vm.$store.getters.isPrivate) {
              tips.error(i18n_t('当前号码未加入企业，请检查账号信息或联系企业管理员添加成员身份！'), 5000);
            } else {
              methods.emitNoEnterprise();
            }
          } else if ((smsResult.error as any).code === 'PhoneNumberInSmsBlackList') {
            errorPhoneTips();
          } else {
            tips.error(smsResult.error as MsgError);
          }
        }
      },
      // 登录
      async confirmToLogin() {
        if (!methods.validate()) {
          return;
        }
        loginStep.value = 'logining';
        const { loginFunc, invitationCode } = user.getUserInfoSync();
        const { channelTag } = getChannel(vistorLogin.value);
        tips.loading(i18n_t('正在登录'), 0);
        const loginParams = {
          countryCode: formData.code,
          phoneNumber: formData.phoneNumber,
          code: formData.sms,
          deviceId: getDeviceName(),
          ...(!store.getters.isPrivate && {
            domain: CONSTANT_URL.currentDomain,
          }),
          ...(captchaInfo.captchaTicket && captchaInfo),
          ...(loginFunc === User.LoginFuncKey.loginToJoin && {
            inviteCode: invitationCode,
          }),
          ...(channelTag && {
            pf: channelTag,
          }),
          collectToken: vm.$store.getters.collectToken,
        };
        const res = await store.dispatch('loginSMS', loginParams);
        if (res.hasError) {
          tips.closeAll();
          // 需要图形验证码
          if (['GraphicCaptchaNotFound', 'InvalidGraphicCaptcha'].includes(res.code)) {
            captcha.show();
          } else if (res.code === 'PhoneNumberNotInAllowlist') {
            reporter.report('login_not_joined', {
              tips: 'true',
            });
            if (vm.$store.getters.isPrivate) {
              tips.error(i18n_t('当前号码未加入企业，请检查账号信息或联系企业管理员添加成员身份！'), 5000);
            } else {
              methods.emitNoEnterprise();
            }
          } else {
            tips.error(res);
          }
          return;
        }
        methods.afterPhoneConfirmed(res, loginParams.phoneNumber);
      },
      // 绑定手机号
      confirmToBindPhone() {
        // 公有云 绑定时需要选中已读协议
        if (!methods.validate()) {
          return;
        }
        if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInWeChat) {
          user.setLoginType(User.LoginTypeKey.loginWithWechat);
          methods.bindPhoneFn('loginByWeChat');
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInWeCom) {
          user.setLoginType(User.LoginTypeKey.loginWithWecom);
          methods.bindPhoneFn('loginByWeCom');
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInMeeting) {
          user.setLoginType(User.LoginTypeKey.loginWithMeeting);
          methods.bindPhoneFn('loginByMeeting');
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInYufu) {
          user.setLoginType(User.LoginTypeKey.loginWithYufu);
          const { tenantKey, tenantType } = user.getUserInfo();
          methods.bindPhoneFn('loginByYufu', { tenantKey, type: tenantType });
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInSSO) {
          user.setLoginType(User.LoginTypeKey.loginWithSSO);
          const { corpid, ssoAccount } = user.getUserInfo();
          const credential = ssoAccount?.credential;
          methods.bindPhoneFn('verifyAccountLogin', { orgDomain: corpid, type: 'sso', credential });
        } else if (loginBindType.value === User.LoginBindTypeKey.bindPhoneInLDAP) {
          user.setLoginType(User.LoginTypeKey.loginWithLDAP);
          const { corpid, ldapAccount } = user.getUserInfo();
          const { ldapType, accountName, accountPassword } = ldapAccount as User.LdapAccount;
          methods.bindPhoneFn('verifyAccountLogin', {
            orgDomain: corpid,
            type: 'account-password',
            ldapType,
            accountName,
            accountPassword,
          });
        }
      },
      // 绑定手机号统一操作
      async bindPhoneFn(type: string, params?: any) {
        tips.loading(i18n_t('正在绑定'));
        const { authCode, loginFunc, invitationCode } = user.getUserInfo();
        const { channelTag } = getChannel();
        const baseParams = {
          countryCode: formData.code,
          phoneNumber: formData.phoneNumber,
          smsCode: formData.sms,
          deviceId: getDeviceName(),
          ...(authCode && { code: authCode }),
          domain: CONSTANT_URL.currentDomain,
          ...(channelTag && { pf: channelTag }),
        };
        if (type === 'loginByWeCom') {
          const { wecomParams } = user.getUserInfo();
          Object.assign(baseParams, wecomParams as User.WecomParams);
        }
        if (loginFunc === User.LoginFuncKey.loginToJoin) {
          Object.assign(baseParams, {
            inviteCode: invitationCode,
          });
        }
        params && Object.assign(baseParams, params);
        try {
          const res = await smh.api[type](baseParams);
          // 绑定出错
          if (res.hasError) {
            tips.closeAll();
            user.setLoginType(User.LoginTypeKey.loginWithPhone);
            user.setLoginAction(User.LoginActionKey.login);
            dispatchRouter({ name: 'login' }, 'replace');
            if (res.code === 'PhoneNumberNotInAllowlist') {
              if (vm.$store.getters.isPrivate) {
                tips.error(i18n_t('当前号码未加入企业，请检查账号信息或联系企业管理员添加成员身份！'), 5000);
              } else {
                methods.emitNoEnterprise();
              }
            } else {
              tips.error(res);
            }
            // ldap、ad域绑定出错时停在本页
            if (type === 'verifyAccountLogin' && params?.type === 'account-password') return;
            user.setLoginAction(User.LoginActionKey.login);
            dispatchRouter({ name: 'login' }, 'replace');
            return;
          }
          // 绑定成功
          methods.afterPhoneConfirmed(res);
        } catch (e: any) {
          tips.error(e);
        }
      },
      // 点击登录/绑定手机号按钮
      async onSubmit(): Promise<void> {
        if (!formData.sms) {
          tips.error(i18n_t('请输入验证码'));
          return;
        }
        if (loginAction.value === 'login') {
          // 登录
          user.setLoginType(User.LoginTypeKey.loginWithPhone);
          methods.confirmToLogin();
        } else {
          // 绑定手机号
          methods.confirmToBindPhone();
        }
      },
      // 手机号校验完成后,
      afterPhoneConfirmed(res: CoFile.LoginSMSData, phoneNumber?: string) {
        // tips.closeAll();
        user.setCountryCode(formData.code);
        user.setPhoneNumber(formData.phoneNumber as string);
        user.setRemember(formData.remember);
        // 内部用户
        const { href } = window.location;
        if (res.organizations.length !== 0) {
          // oauth2下只验证 不登录
          const isOauth2 = checkIsOauth2();
          user.verifyAndLogin(res, isOauth2);
          collectAccessTokenManager.setData({
            collectUserToken: res.userToken,
            visitor: false,
          });
        } else if (href.includes('/web/share') || href.includes('/web/collect')) {
          collectAccessTokenManager.setData({
            collectUserToken: res.userToken,
            visitor: true,
          });
          const vistorInfo: VistorInfo = {
            vistorPhoneNumber: phoneNumber,
            vistorUserToken: res.userToken,
          };
          vistor.verifyAndLogin(vistorInfo);
          ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE);
          tips.closeAll();
        }
      },
      // 清空表单
      initFormData() {
        Object.assign(formData, {
          code: defaultCode,
          phoneNumber: '',
          sms: defaultSms,
          remember: store.getters.remember || false,
        });
      },
      // 取消微信绑定
      cancelBindWechat() {
        context.emit('restore');
        methods.initFormData();
        dispatchRouter({ name: 'login' }, 'replace');
      },
      // 初始化图形验证码
      // 图形验证码在发短信前或登录失败时都会触发
      initCaptcha() {
        try {
          // @ts-ignore
          captcha = new TencentCaptcha(
            '2091142919',
            // @ts-ignore
            res => {
              // 清空
              Object.assign(captchaInfo, {
                captchaTicket: '',
                captchaRandstr: '',
              });
              captcha.destroy();
              // 验证成功
              if (res.ret === 0) {
                Object.assign(captchaInfo, {
                  captchaTicket: res.ticket || '',
                  captchaRandstr: res.randstr || '',
                });
                if (loginStep.value === 'sendingSms') {
                  // 发短信前完成图形验证码后触发发短信逻辑
                  methods.sendSMS();
                } else {
                  // 登录失败时完成图形验证码后触发发登录逻辑
                  methods.confirmToLogin();
                }
              }
            },
            {
              userLanguage: getTencentCaptchaLanguage(i18n.locale),
            },
          );
        } catch (e) {
          logger.ui('TencentCaptcha初始化失败');
        }
      },
      validate() {
        const ref = agreementRef.value;
        const existAgreementRef = ref?.$el.offsetHeight ?? 0 > 0;
        if (existAgreementRef) {
          return agreementRef.value?.validate();
        }
        return true;
      },
    };

    onMounted(() => {
      methods.initCaptcha();
    });
    return {
      LoginActionKeyMap,

      agreementRef,
      phonePrefixOptions,
      channelTag,
      rules,
      isCounting,
      smsText,
      showAgreementPopup,
      formData,
      phoneIsCorrect,
      smsIsCorrect,
      loginAction,
      phoneMaxLen,
      ...methods,
    };
  },
});
